<script setup lang="ts">
import { DEVELOPERS } from '~/constants/easter-egg.constants'

const emits = defineEmits([ 'triggerCredit' ])

const currentIndex = ref(0)
const developer = ref(DEVELOPERS[0])

const shuffleArray = (array: any[]) => {
  return array.sort(() => Math.random() - 0.5)
}

const intervalId = setInterval(() => {
  developer.value = DEVELOPERS[currentIndex.value++]
  if (currentIndex.value >= DEVELOPERS.length) {
    currentIndex.value = 0
    shuffleArray(DEVELOPERS)
  }
}, 4000)

onBeforeMount(() => {
  shuffleArray(DEVELOPERS)
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
  emits('triggerCredit', false)
})
</script>

<template>
  <div
    class="background"
    @click="emits('triggerCredit', false)"
  >
    <span class="label">
      MADE BY
    </span>
    <div class="flex w-full flex-col items-center gap-y-8">
      <div class="name">
        {{ developer.name.toUpperCase() }}
      </div>
      <div class="role">
        {{ developer.role.toUpperCase() }}
      </div>
    </div>
    <span class="label">CLICK TO CLOSE</span>
  </div>
</template>

<style scoped lang="scss">
.background {
  @apply fixed left-0 top-0 flex h-full w-full flex-col justify-between items-center italic bg-black;
  z-index: 9999;
  padding: 10% 0;

  &::after {
    @apply bg-gradient-to-b from-primary/[15%] via-[black_50%] to-primary/[15%] w-full h-full absolute top-0 left-0;
    content: '';
    z-index: -1;
  }
}

.label {
  @apply text-default/40;
  letter-spacing: 0.5rem;
}

.name {
  @apply text-6xl font-bold w-full text-center text-default break-words;
  text-shadow: $primary-color -0.15rem -0.15rem, $secondary-color 0.15rem 0.15rem;
  animation: moveWithShadow 4s infinite linear alternate;

  @include mobile {
    @apply text-4xl;
  }

  @keyframes moveWithShadow {
    from {
      transform: translateX(-200%);
      text-shadow: none;
      opacity: 0;
    }
    20% {
      transform: translateX(-50%);
      opacity: 0;
    }
    25% {
      transform: translateX(-3%);
      opacity: 80%;
    }
    40% {
      transform: translateX(-1%);
      opacity: 100%;
      text-shadow: $primary-color -0.15rem -0.15rem 2px, $secondary-color 0.15rem 0.15rem 2px;

    }
    50% {
      transform: translateX(0%);
      opacity: 100%;
      text-shadow: $primary-color -0.15rem -0.15rem, $secondary-color 0.15rem 0.15rem;
    }
    60% {
      transform: translateX(1%);
      opacity: 100%;
      text-shadow: $primary-color -0.15rem -0.15rem 2px, $secondary-color 0.15rem 0.15rem 2px;
    }
    75% {
      transform: translateX(3%);
      opacity: 80%;
    }
    80% {
      transform: translateX(50%);
      opacity: 0;
    }
    to {
      transform: translateX(200%);
      text-shadow: none;
      opacity: 0;
    }
  }
}

.role {
  @apply text-lg w-full text-center relative;
  letter-spacing: 0.5rem;
  animation: move 4s infinite linear alternate-reverse;

  &::after {
    @apply bg-primary/80 top-0 left-1/4 absolute w-1/2 h-full z-[-1];
    content: '';
    animation: move 4s infinite linear alternate-reverse;
    animation-delay: 0.5s;

    @include mobile {
      @apply -left-1/4;
      width: 150%;
    }
  }

  @keyframes move {
    from {
      @apply text-primary;
      transform: translateX(-300%);
    }
    20% {
      transform: translateX(-50%);
    }
    25% {
      transform: translateX(-3%);
    }
    40% {
      @apply text-default;
      transform: translateX(-1%);
    }
    50% {
      @apply text-default;
      transform: translateX(0%);
    }
    60% {
      @apply text-default;
      transform: translateX(1%);
    }
    75% {
      transform: translateX(3%);
    }
    80% {
      transform: translateX(50%);
    }
    to {
      @apply text-primary;
      transform: translateX(300%);
    }
  }
}
</style>